import React, { Component } from "react";
import {
  NormalButton,
  NormalDate,
  NormalSelect,
  NormalModal,
} from "component/common";
import { InputSearch, TableWrapper } from "component/common";
import { NormalInput, NormalDateTime } from "component/common";
import closeIcon from "assets/images/close.png";
import { dateFormat } from "service/helperFunctions";
import { history } from "helpers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCommonApi, commonCreateApi } from "redux/actions/common";
import { withTranslation } from "react-i18next";
import { NumPadKeyboard } from "component/common/NumPadKeyboard";
import { CredentialConfirmation } from "component/Admin/Cart/credentialConfirmation";
import "./style.scss";
export class PointTabClass extends Component {
  state = {
    headerDetails: [
      {
        label: "Date",
        sortKey: false,
        width: "80px",
        // divClass: "justify-content-end text-right",
      },
      { label: "Transaction #", sortKey: false, width: "80px" },
      // { label: "Treatment #", width: "152px" },
      {
        label: "Type",
        sortKey: false,
        width: "100px",
        // divClass: "justify-content-end text-right",
      },
      {
        label: "Total Point",
        sortKey: false,
        width: "100px",
        // divClass: "justify-content-end text-right",
      },
      {
        label: "Balance Point",
        sortKey: false,
        width: "100px",
        // divClass: "justify-content-end text-right",
      },
      {
        label: "",
        sortKey: false,
        width: "100px",
        // divClass: "justify-content-end text-right",
      },
    ],
    billingList: [],
    pageMeta: {
      chunk: 10,
      page: 1,
      total: 10,
      totalPages: 2,
    },
    formField: {
      fromDate: new Date(),
      toDate: new Date(),
      transCode: "",
      custCode: "",
      custName: "",
      transtype: "All",
    },
    active: false,
    currentIndex: -1,
    page: 1,
    limit: 10,
    isOpenvoidCheckout: false,
    isLoginConfirm: false,
    isLoginConfirm2: false,
    Current_Point: null,
    inputValue: 0,
    result: 0,
    operation: "",
    adjustType: "",
    transtypeOptions: [
      { label: "All", value: "All" },
      { label: "Sales", value: "Sales" },
      { label: "Void", value: "Void" },
      { label: "TD", value: "TD" },
    ],
    customer_id: "",
  };

  componentDidMount() {
    this.setState({ customer_id: this.props.id }, () => {
      console.log(
        this.state.customer_id,
        "customer_idcustomer_idcustomer_idcustomer_id"
      );
      this.getTransactions(this.state.customer_id);
    });

    let From = new Date();
    let { formField } = this.state;
    let firstdayMonth = new Date(From.getFullYear() - 2, From.getMonth(), 1);
    formField["fromDate"] = firstdayMonth;
    this.setState({
      formField,
    });
  }

  getTransactions = () => {
    let { billingList, pageMeta, formField, page, limit, customer_id } =
      this.state;

    let { fromDate, toDate, transCode, custCode, custName, transtype } =
      formField;

    let From = new Date();
    if (fromDate && fromDate !== "") {
      From = fromDate;
    } else {
      this.setState({ fromDate: From });
    }
    let To = new Date();
    if (toDate && toDate !== "") {
      To = toDate;
    } else {
      this.setState({ toDate: To });
    }
    this.props
      // .getCommonApi(`customerpointslist/?cust_id=234744&page=${page}&limit=${limit}`)
      .getCommonApi(
        `customerpointslist/?cust_id=${customer_id}&page=${page}&limit=${limit}`
      )
      .then(async (res) => {
        console.log(res, "dsfdfaafg");
        await this.setState({ billingList: [] });
        billingList = res.data.dataList;
        pageMeta = res.data.meta.pagination;
        // pageMeta = res.data.meta.pagination;

        this.setState({ billingList, pageMeta });
      });
  };
  handlePrint = (id) => {
    let { billingList, pageMeta, formField, page, limit } = this.state;
    let { fromDate, toDate, transCode, custCode, custName } = formField;
    this.props.getCommonApi(`receiptpdf/?sa_transacno=${id}`).then((res) => {});
  };

  handlePagination = async (pageNo) => {
    let { page } = this.state;
    page = pageNo.page;
    await this.setState({
      page,
    });
    this.getTransactions();
  };

  handleShare = (id) => {
    this.props
      .commonCreateApi(`receiptpdfsend/?sa_transacno=${id}`)
      .then((res) => {});
  };

  handleInvoice = (id) => {
    this.props
      .getCommonApi(`customerreceiptprint/?sa_transacno=${id}`)
      .then((res) => {});
  };

  handleInputChange = (event) => {
    const inputValue = event.target.value;
    const { Current_Point, operation } = this.state;
    let result;
    console.log(inputValue, "inputValue inputValue");

    if (inputValue === "") {
      result = Current_Point;
    } else if (operation === "+") {
      result = parseFloat(Current_Point) + parseFloat(inputValue);
    } else if (operation === "-") {
      result = parseFloat(Current_Point) - parseFloat(inputValue);
    } else {
      result = Current_Point;
    }

    this.setState({ inputValue, result });
  };

  handleOperationChange = (event) => {
    const operation = event.target.value;
    this.setState({ operation });
    const adjustTypeValue = event.target.value; // Capture the selected value from the dropdown

    // Set the adjustType based on the selected value
    let adjustType;
    if (adjustTypeValue === "+") {
      const addTotalPoint =
        parseFloat(this.state.result) + parseFloat(this.state.inputValue);
      this.setState({ result: addTotalPoint });
      adjustType = "Reward";
    } else if (adjustTypeValue === "-") {
      const subTotalPoint =
        parseFloat(this.state.result) - parseFloat(this.state.inputValue);
      this.setState({ result: subTotalPoint });
      adjustType = "Redeem";
    } else {
      adjustType = ""; // Handle other cases as needed
    }

    this.setState({ adjustType });
  };

  componentDidUpdate() {
    if (this.state.statusCode === 201) {
      this.handleConfrom();
    }
  }

  handleConfrom = () => {
    const { customer_id } = this.state;

    const { inputValue, adjustType } = this.state;
    // const parsedInputValue = Number(inputValue).toFixed(2)
    const parsedInputValue = parseFloat(inputValue);
    console.log(parsedInputValue, "parsedInputValue parsedInputValue");
    if (
      Number.isNaN(parsedInputValue) ||
      parsedInputValue === null ||
      parsedInputValue === undefined
    ) {
      parsedInputValue = 0;
    }
    const remarksText = document.getElementById("remarksInput").value;
    const payload = {
      cust_id: customer_id,
      total_point: parsedInputValue,
      remarks: remarksText,
      ref_source: "Sales Manual Point",
      adjust_type: adjustType,
    };
    this.props.commonCreateApi(`manualrewardpoint/`, payload).then((res) => {
      this.setState((prevState) => ({
        isLoginConfirm2: !prevState.isLoginConfirm2,
      }));

      this.getTransactions(customer_id);
      console.log(res.data, "#######__%%%%%%");
    });
  };

  handleClick = (key) => {
    if (!this.state.active) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    this.setState((prevState) => ({
      active: !prevState.active,
      currentIndex: key,
    }));
  };

  handleOutsideClick = (e) => {
    if (this.node != null) {
      if (this.node.contains(e.target)) {
        return;
      }
    }
    this.handleClick();
  };

  handleChange = async ({ target: { value, name } }) => {
    let { formField } = this.state;
    formField[name] = value;
    await this.setState({
      formField,
    });
  };
  F;

  // handleToChangeInput
  handleTextInputValue = async (value, name) => {
    let { formField } = this.state;
    formField[name] = value;
    await this.setState({
      formField,
    });
  };

  handleDatePick = async (name, value) => {
    let { formField } = this.state;
    formField[name] = value;
    await this.setState({
      formField,
    });
  };

  handleSearch = () => {
    this.getTransactions();
  };

  handleauthentication = async (user, pass) => {
    // const { customer_id  } = this.state;

    let Body = {
      username: user,
      password: pass,
      type: "Void",
    };
    this.props
      .commonCreateApi(`userauthorizationpopup/`, Body)
      .then(async (key) => {
        let { status, data } = key;
        if (status == 200) {
          await this.setState((prevState) => ({
            isLoginConfirm: !prevState.isLoginConfirm,
            isLoginConfirm2: !prevState.isLoginConfirm2,
          }));
          this.handlemanualrewardpoint();
        }
      });
  };

  handlemanualrewardpoint = () => {
    const { customer_id } = this.state;
    console.log(customer_id, "customer_id ,id  customer_id ,id ");
    this.props
      .getCommonApi(
        `manualrewardpoint/getmanualpointadjustment/?cust_id=${customer_id}`
      )
      .then((res) => {
        console.log(res.data.cust_point_value, "))))))))))))))))(((((((((((");
        const Current_Point = res.data.cust_point_value;
        this.setState({ Current_Point });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  handleLoginConfirmationDialog = async () => {
    await this.setState((prevState) => ({
      isLoginConfirm: !prevState.isLoginConfirm,
    }));
  };
  handleLoginConfirmationDialog2 = async () => {
    this.handlemanualrewardpoint();

    await this.setState((prevState) => ({
      isLoginConfirm2: !prevState.isLoginConfirm2,
    }));
  };

  render() {
    let {
      headerDetails,
      pageMeta,
      billingList,
      formField,
      transtypeOptions,
      isLoginConfirm,
      isLoginConfirm2,
      Current_Point,
      inputValue,
      result,
    } = this.state;
    let { fromDate, toDate, transCode, custCode, custName, transtype } =
      formField;
    let { t } = this.props;
    return (
      <>
        <div className="invoice-History mt-1">
          <div className="row m-0">
            {/* <div className="col-4">
              <div className="d-flex mb-2">
                <label className="text-left w-100 text-black common-label-text">
                  {t("From Date")}
                </label>
                <div className="input-group">
                  <NormalDateTime
                    onChange={this.handleDatePick}
                    value={fromDate ? new Date(fromDate) : new Date()}
                    name="fromDate"
                    showYearDropdown={true}
                    dateFormat="dd/MM/yyyy"
                    type="date"
                    maxDate={new Date(toDate)}
                  />
                </div>
              </div>
              <div className="d-flex mb-2">
                <label className="text-left w-100 text-black common-label-text">
                  {t("To Date")}
                </label>
                <div className="input-group">
                  <NormalDateTime
                    onChange={this.handleDatePick}
                    inputcol="p-0 inTime"
                    value={toDate ? new Date(toDate) : new Date()}
                    name="toDate"
                    className="dob-pick"
                    showYearDropdown={true}
                    dateFormat="dd/MM/yyyy"
                    type="date"
                    minDate={new Date(fromDate)}
                  />
                </div>
              </div>
            </div> */}

            {/* <div className="col-4">
              <div className="d-flex mb-2">
                <label className="text-left w-100 text-black common-label-text mr-2">
                  {t("Transaction Code")}
                </label>
                {this.props.tokenDetails.ipadkey ? (
                  <NumPadKeyboard
                    onChange={(val) =>
                      this.handleTextInputValue(val, "transCode")
                    }
                    value={transCode}
                    decimal={false}
                  />
                ) : (
                  <div className="input-group">
                    <NormalInput
                      value={transCode}
                      name="transCode"
                      onChange={this.handleChange}
                    />
                  </div>
                )}
              </div>
              <div className="d-flex mb-2">
                <label className="text-left w-100 text-black common-label-text">
                  {t("Transaction Type")}
                </label>
                <div className="input-group">
                  <NormalSelect
                    placeholderrequired={false}
                    options={transtypeOptions}
                    value={transtype}
                    iconname="icon-down-key"
                    name="transtype"
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div> */}
            {/* 
            <div className="col-3">
              <NormalButton
                buttonClass={"mx-2"}
                mainbg={true}
                className=" fs-15 confirm"
                label="Search"
                outline={false}
                onClick={this.handleSearch}
              />
            </div> */}
          </div>

          <div className="billing-table">
            <div className="py-4">
              <div className="table-container">
                <TableWrapper
                  headerDetails={headerDetails}
                  queryHandler={this.handlePagination}
                  pageMeta={pageMeta}
                >
                  {billingList
                    ? billingList.map((item, index) => {
                        // console.log("item" + JSON.stringify(item));
                        let {
                          icon,
                          id,
                          sa_custno,
                          sa_custname,
                          date,
                          time,
                          transaction,
                          type,
                          total_point,
                          bal_point,
                          // sa_totamt,
                          // sa_transacno_ref,
                          // void_refno,
                          // sa_staffname,
                          // sa_status,
                          // sa_transacno_type,
                          sa_transacno,
                          no_of_lines,
                          no_of_qty,
                          itemsite_code,
                          now_point,
                        } = item;
                        return (
                          <tr key={index}>
                            {/* <td>
                              <div className="text-left">{sa_custno}</div>
                            </td>
                            <td>
                              <div className="text-left">{sa_custname}</div>
                            </td> */}
                            <td>
                              <div className="text-left">
                                {date} &nbsp;
                                {time}
                              </div>
                            </td>
                            <td>
                              <div className="text-left">{sa_transacno}</div>
                            </td>
                            <td>
                              <div className="text-left">{type}</div>
                            </td>
                            <td>
                              <div className="text-left">{total_point}</div>
                            </td>
                            <td>
                              <div className="text-left">{now_point}</div>
                            </td>
                            {/* <td>
                              <div className="text-left">
                                {sa_transacno_type}
                              </div>
                            </td>

                            <td>
                              <div className="text-left">{sa_staffname}</div>
                            </td> */}

                            <td className="position-relative">
                              {sa_transacno !== "" && (
                                <>
                                  <NormalButton
                                    buttonClass={"mx-0"}
                                    mainbg={true}
                                    className=" fs-15 confirm"
                                    label="View"
                                    outline={false}
                                    onClick={() =>
                                      history.push(
                                        `/admin/transactionhistory/print/bill/${sa_transacno}`
                                      )
                                    }
                                  />
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </TableWrapper>
                <div>
                  <div className=" mt-4 text-center">
                    <NormalButton
                      mainbg={false}
                      className="col-2 submit-btn"
                      label="Manual Point"
                      onClick={() => this.handleLoginConfirmationDialog()}
                    />
                  </div>
                  {/* <p
                    style={{ color: "red", textAlign: "center" }}
                    onClick={this.handleLoginConfirmationDialog}
                  >
                    Manual point
                  </p> */}

                  <NormalModal
                    className={"d-flex justify-content-center"}
                    style={{ minWidth: "20%" }}
                    modal={isLoginConfirm}
                    handleModal={() => {}}
                  >
                    <img
                      onClick={this.handleLoginConfirmationDialog}
                      className="close cursor-pointer"
                      src={closeIcon}
                      alt=""
                    />
                    <CredentialConfirmation
                      handleLoginSubmit={(user, pass) =>
                        this.handleauthentication(user, pass)
                      }
                    />
                  </NormalModal>
                </div>

                <div>
                  {/* <p
                    style={{ color: "red", textAlign: "center" }}
                    onClick={this.handleLoginConfirmationDialog2}
                  >
                    Hello point
                  </p> */}

                  <NormalModal
                    className={"d-flex justify-content-center"}
                    style={{ minWidth: "50%", height: "55%" }}
                    modal={isLoginConfirm2}
                    handleModal={() => {}}
                  >
                    <img
                      onClick={this.handleLoginConfirmationDialog2}
                      className="close cursor-pointer"
                      src={closeIcon}
                      alt=""
                    />
                    <div>
                      <div>
                        <div>
                          <p>Manual Point Adjustment </p>
                        </div>
                        <br />

                        <div>
                          <p>Current Point : {Current_Point}</p>
                        </div>
                        <br />

                        <div>
                          <p>
                            Adjustment Point :{Number(inputValue).toFixed(2)}
                          </p>
                        </div>
                        <br />

                        <div>
                          {/* <p>New Point: {result} </p> */}
                          <p>New Point: {Number(result).toFixed(2)} </p>
                        </div>
                        <br />

                        <div style={{ display: "flex", gap: 100 }}>
                          <div>
                            <p>Adjustment </p>
                          </div>
                          <div>
                            <select
                              id="dropdown"
                              style={{ width: 175 }}
                              onChange={this.handleOperationChange}
                            >
                              <option value="">choose an option</option>
                              <option value="+">+</option>
                              <option value="-">-</option>
                            </select>
                          </div>

                          <div>
                            <input
                              type="number"
                              value={inputValue}
                              onChange={this.handleInputChange}
                            />
                          </div>
                        </div>
                        <br />

                        <div style={{ display: "flex", gap: 150 }}>
                          <div>
                            <p>Reason</p>
                          </div>
                          <div>
                            <input type="text" id="remarksInput" />
                          </div>
                        </div>
                      </div>
                      <br />
                      <br />

                      <div style={{ display: "flex", justifyContent: "end" }}>
                        <button
                          onClick={() => this.handleConfrom()}
                          className="submit-btn"
                        >
                          Confirm
                        </button>
                      </div>
                    </div>
                  </NormalModal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  tokenDetails: state.authStore.tokenDetails,
});
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      commonCreateApi,
    },
    dispatch
  );
};

export const PointTab = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(PointTabClass)
);